import Rest from '../Rest'

export default class CancellationPolicyService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/cancellation_policies'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getVersions(policyId: number) {
    return this.get(`/${policyId}/versions`)
  }

  saveVersion(policyId: number, data: any) {
    return this.post(`/${policyId}/versions`, data)
  }

  simulate(data: any) {
    return this.post('/simulate', data)
  }
}
